@if (mediaPicture()) {
    <picture>
        @for (
            mediaQueryOptions of mediaQueriesOptions() ?? defaultMediaQueriesOptions;
            track trackBySize($index, mediaQueryOptions)
        ) {
            <source
                [attr.media]="mediaQueryOptions.mediaQuery"
                [attr.srcset]="
                    mediaUrl()
                        | hPosterUrl
                            : {
                                  mobileUrl: mediaPicture()?.mobileImage,
                                  size: mediaQueryOptions.size,
                                  width: mediaQueryOptions.width,
                                  height: mediaQueryOptions.height,
                                  fit: mediaQueryOptions.fit,
                              }
                " />
        }
        <!-- Image have a src placeholder so Safari doesn't load the source src and img src : https://github.com/facebook/react/issues/22684#issuecomment-1140121463 -->
        <img
            class="full-parent"
            [style.min-height]="minHeight()"
            [src]="'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw=='"
            [alt]="imageAlt()"
            [attr.fetchpriority]="preload() ? 'high' : 'auto'"
            [attr.loading]="preload() ? 'eager' : 'lazy'" />
        @if (title()) {
            <figcaption class="media-title-overlay">
                <div class="title">{{ title() }}</div>
            </figcaption>
        }
    </picture>
}
